import axiosClient from "./axiosClient";

const categoryApi = {
  getAll: () => axiosClient.get("/categories/?page=1&limit=10"),
  getById: (id) => axiosClient.get(`/categories/${id}`),
  create: (data) => axiosClient.post("/admin/categories", data),
  update: (id, data) => axiosClient.patch(`/admin/categories/${id}`, data),
  updateImage: (id, data) => axiosClient.put(`/admin/categories/${id}`, data),
  delete: (id) => axiosClient.delete(`/admin/categories/${id}`)
};

export default categoryApi;
